import axios from 'axios';

import type { ServerResponse, Template, TemplatePayload } from '../../@types/types';
import { getRequestAuth } from '../helpers/getRequestAuth';

export const updateTemplate = async (
  id: string,
  data: TemplatePayload,
  authToken: string
): Promise<Omit<ServerResponse<Template>, 'schemas'>> => {
  const auth = await getRequestAuth(authToken);

  const response = await axios({
    method: 'patch',
    url: `${process.env.REACT_APP_API_URL}/templates-spa-${auth.authProvider}/${id}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.token,
    },
    data,
  });

  return response.data;
};
